<div class="admin-layout border-left border-top">
    <div class="cp-content p-3" style="height: calc(100vh - 176px);">
        <div class="card" *ngIf="eventNotFound">
            <div class="card-body text-center">
                Không tìm thấy lịch
            </div>
        </div>
        <div [ngClass]="{'hide': eventNotFound}" class="row">
                <div class="col-md-12 mb-3">
                    <div class="form-group">
                        <label class="font-weight-bold">Tiêu đề (<span class="text-danger">*</span>):</label>
                        <input #titleInput type="text" class="form-control"
                               [(ngModel)]="formData.title"
                               [ngClass]="{'is-invalid': titleInput.value.trim().length === 0}">
                    </div>
                    <div class="form-group row">
                        <div class="col-2" style="padding-right:5px">
                            <label class="font-weight-bold">Ngày sự kiện (<span class="text-danger">*</span>):</label>
                            <input type="text" class="form-control"
                                   [(ngModel)]="formData.date"
                                   [ngClass]="{'is-invalid': formData.date.length === 0}"
                                   #dp="bsDatepicker"
                                   bsDatepicker
                                   [bsConfig]="{dateInputFormat: 'DD/MM/YYYY'}">
                        </div>
                        <div *ngIf="!allDay.checked" class="col-2" style="padding-right:5px;padding-left:5px">
                            <label class="font-weight-bold">Từ giờ (<span class="text-danger">*</span>):</label>
                            <input type="text" class="form-control"
                                   [(ngModel)]="formData.startTime"
                                   [ngClass]="{'is-invalid': (timeError || formData.startTime.length === 0)}"
                                   timePicker
                                   [timePickerModal]="timeStartModal">
                            <time-picker-modal #timeStartModal></time-picker-modal>
                        </div>
                        <div *ngIf="!allDay.checked" class="col-2" style="padding-left:5px">
                            <label class="font-weight-bold">Đến giờ (<span class="text-danger">*</span>):</label>
                            <input type="text" class="form-control"
                                   [(ngModel)]="formData.toTime"
                                   [ngClass]="{'is-invalid': (timeError || formData.toTime.length === 0)}"
                                   timePicker
                                   [timePickerModal]="timeEndModal">
                            <time-picker-modal #timeEndModal></time-picker-modal>
                        </div>
                        <div class="col-2 pl-4 mt-4 d-flex align-items-center">
                            <input #allDay [(ngModel)]="formData._allday" type="checkbox" id="_allday" class="form-check-input" value="true"/>
                            <label class="form-check-label font-weight-bold" for="_allday">Cả ngày</label>
                        </div>
                        <div class="col pl-0 pr-0 mt-4 d-flex align-items-center">
                            <input (click)="openRepeats(repeat.checked)"
                                   #repeat
                                   [(ngModel)]="formData.repeat"
                                   class="form-check-input"
                                   id="repeat" type="checkbox" value="true"/>
                            <label class="form-check-label font-weight-bold" for="repeat">Lặp lịch</label>
<!--                            <span *ngIf="repeatText">-->
<!--                            <b>:</b> {{repeatText}}-->
<!--                                <i (click)="onEditRepeat($event)" class="fa fa-pencil" style="padding: 5px;margin: -5px 0;cursor: pointer;" title="Chỉnh sửa"></i>-->
<!--                        </span>-->
                        </div>
                    </div>

                        <calendar-repeat-modal *ngIf="formData.repeat" #repeatModal (onRepeat)="setRepeatEvent($event)"></calendar-repeat-modal>
                    <div [hidden]="!event.myAttendee" class="form-group form-check pl-0">
                        <label class="font-weight-bold">Bạn có tham dự không?</label>
                        <div class="input-group">
                            <select [(ngModel)]="formData.state" class="attendee-select form-control" style="margin-right:-3px">
                                <option value="ACCEPTED">Có</option>
                                <option value="DECLINED">Không</option>
                                <option value="NEEDS_ACTION">Có thể</option>
                            </select>
                            <input [(ngModel)]="formData.notes" type="text" class="form-control" placeholder="Ghi chú">
                        </div>
                    </div>

                    <div class="form-group form-check pl-0">
                        <label class="font-weight-bold">Thành phần: </label>
                        <ng-select
                                [items]="_attendees"
                                [multiple]="true"
                                bindLabel="fullname"
                                [(ngModel)]="attendees">

                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                <span class="ng-value-label"><img userAvatar [usercode]="item.username" width="20px" height="20px"> {{item.fullname}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </ng-template>

                            <ng-template ng-option-tmp let-item="item">
                                <img userAvatar [usercode]="item.username" width="20px" height="20px"> {{item.fullname}}
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">Địa điểm:</label>
                        <input type="text" class="form-control"
                               [(ngModel)]="formData.location"
                               [typeahead]="locationSearch">
                    </div>
                    <div class="form-group">
                        <label class="font-weight-bold">Mô tả:</label>
                        <textarea (keydown.enter)="$event.stopPropagation()" type="text" class="form-control"
                                  [(ngModel)]="formData.summary"></textarea>
                    </div>
                    <div class="form-group">
                        <button (click)="fileAttachment.click()" title="Tập tin đính kèm" type="button" class="btn btn-primary btn-sm rounded">
                            <i class="fa fa-cloud-upload pr-1" aria-hidden="true"></i>
                            <span>Đính kèm</span>
                            <input #fileAttachment type="file" multiple style="display:none">
                        </button>
                        <div style="margin-top: 10px">
                            <calendar-attachment-list
                                    [calEvent]="event"
                                    [removable]="true"
                                    [fileEl]="fileAttachment"></calendar-attachment-list>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>
<calendar-dialog-delete #dialogRemove [calEvent]="event" (onDelete)="goBack()" hidden></calendar-dialog-delete>
